import PropTypes from 'prop-types';
import { Card } from 'antd';
import cx from 'classnames';
import { EnvironmentOutlined } from '@ant-design/icons';
import { AccountIcon } from '@ring-icons';
import './index.less';

export default function OnboardedLocation({ location, setActiveLocation, activeLocation, disabled }) {
  return (
    <Card
      data-testid={location.locationId}
      key={location.locationId}
      onClick={() => !disabled && setActiveLocation(location)}
      hoverable={location.hasEntitlements}
      className={cx('location', {
        'location-card-active': activeLocation.locationId === location.locationId,
        'location-card-disabled': disabled,
      })}
    >
      <div className="location-header">
        <EnvironmentOutlined />
        <p>{location.locationName}</p>
      </div>
      <p className="location-address">
        {`${[location.address?.address1, location.address?.address2].filter(Boolean).join(', ')} \n`}
        {`${[location.address?.city, location.address?.state].filter(Boolean).join(', ')} ${location.address?.zipCode}`}
      </p>
      {!location.isOwner && <p className="location-shared--message">Shared locations must be enrolled by the owner.</p>}
      {!location.hasEntitlements && <p className="location-unsubscribed--message">This location is not eligible.</p>}
    </Card>
  );
}

OnboardedLocation.propTypes = {
  location: PropTypes.object.isRequired,
  setActiveLocation: PropTypes.func.isRequired,
  activeLocation: PropTypes.object,
  disabled: PropTypes.bool,
};
